import { render, staticRenderFns } from "./ChangePurchaseProductName.vue?vue&type=template&id=5d0ad137&scoped=true&"
import script from "./ChangePurchaseProductName.vue?vue&type=script&lang=js&"
export * from "./ChangePurchaseProductName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ad137",
  null
  
)

export default component.exports